export default __webpack_public_path__ + "static/media/grua-reclaimer.02b5b381.png";